import React, { useEffect, useState } from 'react'
import NoData from './accounting/NoData'
import { Button, DynamicEntityIndex, Modal } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer, truncateString } from '@reactiveonline/reactive_admin_shared-packages/utils'

const errorLogsTableHeadings = [
  { key: 'error',            label: 'error'          },
  { key: 'body',             label: 'body'           },
  { key: 'entity_type_name', label: 'entityTypeName' },
  { key: 'created_at',       label: 'createdAt'      },
]

const failedPaymentHeadings = [
  { key: 'created_at',          label: 'createdAt'          },
  { key: 'amount',              label: 'amount'             },
  { key: 'terminal_id',         label: 'terminal_id'        },
  { key: 'payment_type',        label: 'payment_type'       },
  { key: 'response_code',       label: 'response_code'      },
  { key: 'transaction_code',    label: 'transaction_code'   },
  { key: 'transaction_origin',  label: 'transaction_origin' },
]

const erroneousInvoicesTableHeadings = [
  { key: 'invoice_number', label: 'invoice_number' },
  { key: 'serial_number',  label: 'serial_number'  },
  { key: 'date_issued',    label: 'date_issued'    },
  { key: 'error_code',     label: 'error_code'     },
  { key: 'error_message',  label: 'error_message'  },
  { key: 'iview_url',      label: 'iview_url'      },
]

const invoiceSearchTableHeadings = [
  { key: 'issue_date', label: 'date_issued' },
  { key: 'invoice_type', label: 'invoice_type' },
  { key: 'mark', label: 'mark' },
  { key: 'invoice_number', label: 'invoice_number' },
  { key: 'entity_number', label: 'entity_number' },
  { key: 'net_total', label: 'net_total' },
  { key: 'total', label: 'total' },
  { key: 'vat_total', label: 'vat_total' },
  { key: 'series', label: 'series' },
  { key: 'branch', label: 'branch' },
  { key: 'payment_type', label: 'payment_type' },
  { key: 'url', label: 'iview_url' },
  { key: 'counterpart_company', label: 'counterpart_company' },
  { key: 'counterpart_vat', label: 'counterpart_vat' },
  { key: 'counterpart_address', label: 'counterpart_address' },
  { key: 'tid', label: 'tid' },
]

export default function DataTab({
  entityInvoiceSearchPath, erroneousInvoicesPath, errorLogsPath, failedPaymentsPath, getUsageDataPath, setLoading, totalInvoices, usageData, setUsageData, paymentMethods, latestIssuedInvoice
}) {
  const [errorLogs, setErrorLogs]                                 = useState([])
  const [failedPayments, setFailedPayments]                       = useState([])
  const [erroneousInvoices, setErroneousInvoices]                 = useState([])
  const [showDataModal, setShowDataModal]                         = useState(false)
  const [searchInvoiceField, setSearchInvoiceField]               = useState('')
  const [entityInvoiceSearchResult, setEntityInvoiceSearchResult] = useState(null)

  useEffect(() => {
    if (!usageData) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: getUsageDataPath,
        dataType: 'json',
        success: res => {
          setUsageData(res.usageData)
          setLoading(false)
        }
      })
    }
  }, [])

  function itemRenderer(item, columns) {
    return (
      <>
        { columns.map( column => {
          if (column.label === 'error' || column.label === 'body') {
            return (
              <div key={ column.label } className='item flex-1'>
                { truncateString(item[column.label], 50) }
                { item[column.label] && item[column.label].length > 50 &&
                  <i className='pointer m-l-10 m-r-10 fa-light fa-square-info' onClick={ ()=> setShowDataModal(item[column.label]) } />
                }
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  function erroneousInvoicesItemRenderer(item, columns) {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'error_message') {
            return (
              <div key={ column.label } className='item flex-1'>
                { truncateString(item[column.label], 50) }
                { item[column.label] && item[column.label].length > 50 &&
                  <i className='pointer m-l-10 m-r-10 fa-light fa-square-info' onClick={ ()=> setShowDataModal(item[column.label]) } />
                }
              </div>
            )
          } else if (column.label === 'iview_url') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ item[column.label] } target='_blank'>
                  { truncateString(item[column.label], 50) }
                </a>
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  const entityInvoiceSearch = _e => {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: `${ entityInvoiceSearchPath }?search=${ searchInvoiceField }`,
      dataType: 'json',
      success: res => {
        setEntityInvoiceSearchResult(res.data)
        setLoading(false)
      }
    })
  }

  const entityInvoiceRenderer = (item, column) => {
    if (column.label === 'iview_url') {
      return(
        <div key={ column.label } className='item flex-1'>
          <a href={ item[column.key] } target='_blank'>
            { truncateString(item[column.key], 20) }
          </a>
        </div>
      )
    } else {
      return (
        <div key={ column.label } className='item flex-1'>
          { item[column.key] }
        </div>   
      )
    }
  }

  return (
    <>
      <div className='card'>
        <div className='card-content'>
          <div className='card-title m-b-20'>
            { Support.translations.account.employees }
          </div>

          <div className='card-body'>
            { !!usageData && !!usageData.employees?.length
              ? <table className='responsive-table'>
                  <thead>
                    <tr>
                      <th>{ Support.translations.account.employee_name }</th>
                      <th>{ Support.translations.account.employee_pin }</th>
                      <th>{ Support.translations.account.employee_permissions }</th>
                      <th>{ Support.translations.account.session_start_time }</th>
                      <th>{ Support.translations.account.operating_system }</th>
                      <th>{ Support.translations.account.app_version }</th>
                      <th>{ Support.translations.account.mode }</th>
                    </tr>
                  </thead>
                  <tbody>
                    { usageData.employees.map((employee, idx) => (
                      <tr key={ idx }>
                        <td>{ employee.fullName }</td>
                        <td>{ employee.pin }</td>
                        <td>{ employee.permissions }</td>
                        <td>{ employee.latestSession.startTime ?? '-' }</td>
                        <td>{ employee.latestSession.os ?? '-' }</td>
                        <td>{ employee.latestSession.appVersion ?? '-' }</td>
                        <td>{ employee.latestSession.mode ?? '-' }</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              : <NoData />
            }
          </div>
        </div>
      </div>

      <div>
        <DynamicEntityIndex
          initialItems={ errorLogs }
          setInitialItems={ setErrorLogs }
          disableDelete
          disableCustomization
          disableSearch
          entity={ 'error_logs' }
          tableHeadings={ errorLogsTableHeadings }
          itemRenderer={ itemRenderer }
          itemsPath={ errorLogsPath }
          icon='fa-bomb'
          noResourcesTitle={ Support.translations.account.no_error_logs }
          listColumns={ errorLogsTableHeadings }
          columnTranslations={ Support.translations.columns }
          fetchOnStart
          disableUrlUpdates
          headline={ Support.translations.account.error_logs }
        />
      </div>

      <div>
        <DynamicEntityIndex
          initialItems={ failedPayments }
          setInitialItems={ setFailedPayments }
          disableDelete
          disableCustomization
          disableSearch
          tableHeadings={ failedPaymentHeadings }
          itemRenderer={ (item, columns) => columns.map(column => dynamicTableItemRenderer(item, column)) }
          itemsPath={ failedPaymentsPath }
          icon='fa-circle-exclamation'
          noResourcesTitle={ Support.translations.account.no_failed_payments }
          listColumns={ failedPaymentHeadings }
          columnTranslations={ Support.translations.columns }
          fetchOnStart
          disableUrlUpdates
          headline={ Support.translations.account.failed_payments }
        />
      </div>

      <div>
        <div className='card'>
          <div className='card-content'>
            <div className='card-title'>
              { Support.translations.account.invoices }
            </div>

            <div className='card-body'>
              <div>
                { Support.translations.account.total_invoices }: { totalInvoices }
              </div>

              { latestIssuedInvoice &&
                <div>
                  { Support.translations.account.latest_issued_invoice }: { latestIssuedInvoice }
                </div>
              }

              <div>
                <div className={ 'input-field' }>
                  <label>
                    { Support.translations.tenant.search_for_invoice }
                  </label>
                  
                  <div className='flex-box content-start' style={{ gap: 10 }}>
                    <div>
                      <input
                        type='text'
                        value={ searchInvoiceField }
                        onChange={ e => setSearchInvoiceField(e.target.value) }
                      />
                    </div>
                    <div>
                      <Button
                        value={ Support.translations.search }
                        className='btn'
                        onClick={ entityInvoiceSearch }
                      />
                    </div>
                  </div>
                </div>

              </div>

              { !!entityInvoiceSearchResult &&
                <>
                  <DynamicEntityIndex
                    initialItems={ entityInvoiceSearchResult }
                    initialTotalPages={ 1 }
                    tabs={ [] }
                    tableHeadings={ invoiceSearchTableHeadings }
                    itemRenderer={ (item, columns) => columns.map(column => entityInvoiceRenderer(item, column)) }
                    icon={ 'fa-file-invoice' }
                    noResourcesTitle={ Support.translations.account.no_invoices }
                    disableDelete
                    disableSearch
                    disableCustomization
                    disableReload
                    forceUpdateItems
                    disableUrlUpdates
                  />
                </>
              }
            </div>
          </div>
        </div>

        <DynamicEntityIndex
          initialItems={ erroneousInvoices }
          setInitialItems={ setErroneousInvoices }
          disableDelete
          disableCustomization
          disableSearch
          entity={ 'entity_invoices' }
          tableHeadings={ erroneousInvoicesTableHeadings }
          itemRenderer={ erroneousInvoicesItemRenderer }
          itemsPath={ erroneousInvoicesPath }
          icon='fa-receipt'
          noResourcesTitle={ Support.translations.account.no_erroneous_invoices }
          listColumns={ erroneousInvoicesTableHeadings }
          columnTranslations={ Support.translations.columns }
          fetchOnStart
          disableUrlUpdates
          headline={ Support.translations.account.erroneous_invoices }
        />
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-title m-b-20'>
            { Support.translations.account.payment_methods_title }
          </div>

          <div className='card-body'>
            { !!paymentMethods && !!paymentMethods.length
              ? <table className='responsive-table'>
                  <thead>
                    <tr>
                      <th>{ Support.translations.account.payment_method_attrs.type }</th>
                      <th>{ Support.translations.account.payment_method_attrs.name }</th>
                      <th>{ Support.translations.account.payment_method_attrs.active }</th>
                      <th>{ Support.translations.account.payment_method_attrs.username }</th>
                      <th>{ Support.translations.account.payment_method_attrs.archived_at }</th>
                    </tr>
                  </thead>
                  <tbody>
                    { paymentMethods.map((paymentMethod, idx) => (
                      <tr key={ idx }>
                        <td>{ paymentMethod.type }</td>
                        <td>{ paymentMethod.name }</td>
                        <td>
                          <i 
                            className={ paymentMethod.active ? 'fa-light fa-circle-check' : 'fa-light fa-circle-xmark' }
                            style={{ color: paymentMethod.active ? 'green' : 'red' }}
                          />
                        </td>
                        <td>{ paymentMethod.username ?? '-' }</td>
                        <td>{ paymentMethod.archivedAt ?? '-' }</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              : <NoData />
            }
          </div>
        </div>
      </div>

      { showDataModal &&
        <Modal
          visible
          mode='medium'
          action={ ()=> setShowDataModal(false) }
          actionText={ ReactiveCore.translations.close_action }
          closeModal={ ()=> setShowDataModal(false) }
        >
          <div className='m-t-30'>
            { showDataModal }
          </div>
        </Modal>
      }
    </>
  )
}
